<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container"
  >
    <header-area />
    <div :class="readyAction ? 'ready-action' : ''" class="culturePop">
      <div class="cultureList">
        <ul>
          <!-- 210129 add -->
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_time_flex.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[8].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[8].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[8].content") }}
              </p>
            </div>
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="8">&nbsp;TimeFlex TimeFlex</marquee-text></span
                >
                <img src="@/assets/images/culture_img8.jpg" alt="" />
              </div>
            </div>
          </li>
          <!-- //210129 add -->
          <!-- 220621 add -->
          <!--          <li class="step" v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_vacation_bonus.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[9].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[9].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[9].content") }}
              </p>
            </div>
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="8">&nbsp;Vacation Bonus</marquee-text></span>
                <img src="@/assets/images/culture_img9.jpg" alt="" />
              </div>
            </div>
          </li>-->
          <!-- //220621 add -->
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="6">&nbsp;Relax Relax</marquee-text></span
                >
                <img src="@/assets/images/culture_img1.jpg" alt="" />
              </div>
            </div>
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_beach.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[0].title[0]") }}</span
                ><br />
                <span class="familyMono yellow">
                  {{ $t("culture.data[0].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[0].content") }}
              </p>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_firecracker.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[1].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[1].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[1].content") }}
              </p>
            </div>
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="7">&nbsp;Welcome Welcome</marquee-text></span
                >
                <img src="@/assets/images/culture_img2.jpg" alt="" />
              </div>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="5">&nbsp;Thank you</marquee-text></span
                >
                <img src="@/assets/images/culture_img3.jpg" alt="" />
              </div>
            </div>
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_gift.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[3].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[3].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[3].content") }}
              </p>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_certificate.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[4].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[4].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[4].content") }}
              </p>
            </div>
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="8">&nbsp;Specialist Specialist</marquee-text></span
                >
                <img src="@/assets/images/culture_img4.jpg" alt="" />
              </div>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="8">&nbsp;Membership Membership</marquee-text></span
                >
                <img src="@/assets/images/culture_img5.jpg" alt="" />
              </div>
            </div>
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_handshake.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[5].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[5].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[5].content") }}
              </p>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_massage.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[6].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[6].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[6].content") }}
              </p>
            </div>
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="5.4">&nbsp;Health keeper</marquee-text></span
                >
                <img src="@/assets/images/culture_img6.jpg" alt="" />
              </div>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"
                  ><marquee-text :duration="5">&nbsp;Pulip Cafe</marquee-text></span
                >
                <img src="@/assets/images/culture_img7.jpg" alt="" />
              </div>
            </div>
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img src="@/assets/images/emoji_coffee.png" alt="" />
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t("culture.data[7].title[0]") }}</span
                ><br />
                <span class="yellow">
                  {{ $t("culture.data[7].title[1]") }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t("culture.data[7].content") }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <footer-area />
  </div>
</template>

<script>
import { mapState } from "vuex";
import MarqueeText from "vue-marquee-text-component";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
export default {
  mixins: [common],
  name: "Main",
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        /* {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        }, */
        // Open Graph
        { property: "og:title", content: this.meta.title },
        /* { property: "og:description", content: this.meta.desc }, */
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "기업문화 | 플립커뮤니케이션즈",
        title: "기업문화",
        desc:
          "Together, we rise above and beyond. 우리는 사람과 IT가 더욱 가까워질 수 있도록 서로를 이어주는 연결고리가 되길 원합니다. 그렇기에 디지털 세상에 일상을 보다 멋지고 조화롭게 담아내고, 모두가 이용하기 편리하게 만들어 가는 데 집중합니다.",
        keywords:
          "웹에이전시, 디지털에이전시, 디자인에이전시, UIUX에이전시, 디자인회사, 금융권전문웹에이전시, 기업홈페이지제작업체, 기업웹사이트제작업체, 쇼핑몰제작업체, 반응형홈페이지제작업체, 모바일웹개발업체, 모바일앱개발업체, UIUX, 온라인마케팅, 온라인프로모션, 웹기획, 웹디자인, 웹개발, 웹퍼블리싱, 앱기획, 앱디자인, 앱개발, 앱퍼블리싱, 디자인가이드, 디자인시스템, 기업아이덴티티",
        url: "https://www.pulip.com/culture",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      efClass: "",
      readyAction: false
    };
  },
  computed: {
    ...mapState("common", {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    linkList() {
      return this.culturepage.link;
    }
  },
  methods: {},
  mounted() {
    this.readyAction = true;
  }
};
</script>
